import { AuthType, getAuthType } from '@notes/webintegrations-common'
import { USE_IMPLICIT_AUTH_FOR_MSA } from '../../shared/auth/useImplicitAuthForMsa'
import { getO365AccessTokenInfoFromLocalStorage } from './getO365AccessToken'

/**
 * This is a temporary function to get the auth type if access token is present in local storage
 * The getAuthType function in webintegrations-common is updated but due to issues in the pipeline
 * the changes are not yet available in the npm.
 * https://office.visualstudio.com/OneNote/_git/OneNote-WebIntegrations-Common/pullrequest/2842465
 *
 * TODO: Remove this function once the changes are available in webintegrations-common package
 * @returns AuthType
 */
export function getAuthTypeWithExtension(): AuthType | undefined {
  const authType = getAuthType(USE_IMPLICIT_AUTH_FOR_MSA)
  if (authType) {
    return authType
  } else if (getO365AccessTokenInfoFromLocalStorage()) {
    return 'o365'
  }
  return undefined
}
